import { api } from "@/api/client";

export const vanDesignApi = {
  templates: () => api.get("/van-design/templates").then((r) => r.data),
  draft: (body) => api.post("/van-design/draft", body).then((r) => r.data),
  hero: (body) => api.post("/van-design/hero", body).then((r) => r.data),
  listProjects: () => api.get("/van-design/projects").then((r) => r.data.projects),
  saveProject: (body) => api.post("/van-design/projects", body).then((r) => r.data.project),
  getProject: (id) => api.get(`/van-design/projects/${id}`).then((r) => r.data.project),
  deleteProject: (id) => api.delete(`/van-design/projects/${id}`).then((r) => r.data),
};

// Stream a persisted hero image as an authenticated blob URL.
export const streamVanAsset = async (id) => {
  const res = await api.get(`/central-core/vault-file/${id}`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
};
